import React from "react";
import Btn from "@material-ui/core/Button";

type Category = "primary" | "secondary" | "default";

export type ButtonProps = {
  category?: Category;
  onClick?: (v: any) => any;
  children?: React.ReactNode | string;
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  style?: React.CSSProperties;
  component?: string;
};

export const Button = ({
  category = "primary",
  onClick,
  children,
  disabled,
  fullWidth,
  className,
  style,
}: ButtonProps): React.ReactElement => (
  <Btn
    onClick={onClick}
    disabled={disabled}
    fullWidth={fullWidth}
    variant="contained"
    className={className}
    color={category}
    style={style}>
    {children}
  </Btn>
);
